$('.js-change-font-size').change(e => {
	BX.ajax.runComponentAction('main:profile', 'changeFontSize', {
		mode: 'ajax',
		data: {
			font_size: $(e.target).val(),
		},
	})
})